import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DOCUMENTS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  parkDocId: string;
}

const mutatePostDoc = async ({ communityId, parkDocId }: mutateProps) => {
  return await axiosAuth.post(`${DOCUMENTS_API(communityId)}/${parkDocId}/post`);
};

const usePostDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutatePostDoc,
    ...queryParams,
  });

export default usePostDocMutation;
